import React from 'react';
import classNames from 'classnames';

import { Column, Row } from 'components/UIComponents/Layout';
import Heading from '../Heading';

import './style.scss';

export const Title = ({
  children,
  title,
  subtitle,
  prefix,
  dotted = false,
  childrenSpaced = false,
  titleColumnSize = null,
  className,
  ...props
}) => (
  <div
    className={classNames(className, { title__wrap: true, dotted })}
    {...props}
  >
    <Row>
      <Column size={titleColumnSize}>
        <Heading>
          {prefix && <span className="title__prefix">{prefix}</span>}
          <span>{title}</span>
        </Heading>
        {subtitle && (
          <Heading subtitle>
            <span>{subtitle}</span>
          </Heading>
        )}
      </Column>
      {children && (
        <Column>
          <div
            className={`title__children${
              childrenSpaced ? ' title__children--spaced' : ''
            }`}
          >
            {children}
          </div>
        </Column>
      )}
    </Row>
  </div>
);

export default Title;
